// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	IsPurchaserCheckCheckbox: 'is-purchaser-check-checkbox',
	OfferorCheckCheckbox: 'offeror-check-checkbox',
	SetFirstTimeHomeBuyerCheckbox: 'set-first-time-home-buyer-checkbox',
	SpousalStatusDropdown: 'spousal-status-dropdown',
	NameOfOfferor: 'name-of-offeror',
	InstrumentNumber: 'instrument-number',
	PartyClientCard: 'party-client-card',
	FlaSelectionSection: 'fla-selection-section',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
